import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Cruzeiro à Laguna de Alvor a partir de Vilamoura · Morningstar";
const DESC = "Cruzeiro privado de dia a partir de Vilamoura até à laguna de Alvor e ao Algarve ocidental — Benagil, Marinha, Carvoeiro e o estuário protegido de Alvor. Catering a bordo e paragens de mergulho.";
const PATH = "/pt/cruzeiro-laguna-alvor";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/cruzeiro-laguna-alvor")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Laguna de Alvor · Partida de Vilamoura · Algarve",
        title: "Cruzeiro à laguna de Alvor a partir de Vilamoura no ",
        titleAccent: "Morningstar.",
        sub: "Um longo dia privado a oeste — passando por Benagil e Marinha até ao calmo estuário de Alvor. Paragem prolongada de mergulho, almoço a bordo e as falésias mais bonitas do Algarve.",
        ctaPrimary: "Ver itinerário",
        ctaSecondary: "Perguntar sobre Alvor",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "alvor passeio barco, laguna de alvor, vilamoura a alvor barco, algarve ocidental cruzeiro, carvoeiro passeio barco",
      altPath: { en: "/alvor-lagoon-cruise", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Alvor Lagoon Cruise from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Cruzeiro Laguna de Alvor", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
